module.exports = __webpack_public_path__ + "static/media/open-grey.653ffdfe.svg";